import { Injectable } from '@angular/core';
import { List } from 'linqts';
import moment from 'moment';
import { BidLineType, ColorClass } from '../enums/global-enum-constant';
import { BindingManager } from '../models/BindingManager';
import { CalenderData } from '../models/CalenderData';
import { ItemType } from '../models/Constrains/CswUiValues';
import { BidLineTemplate, Lines } from '../models/line';
import { OSVersion } from '../models/OSVersion';
import { TblBidDataDisplay } from '../models/TblBidDataDisplay';
import { DataColumn, SummaryVacationColumn } from '../models/WbidINI';
import * as CryptoJS from 'crypto-js';
import {
  LogData,
  LogDetails,
  OffLineEvents,
} from 'src/app/shared/models/LogDetails';
import { environment } from 'src/environments/environment.prod';
import { WbidCoreService } from '../services/wbid-core.service';
import { CrashMailService } from '../services/crash-mail.service';
import { LoadingSpinnerService } from '../services/loading-spinner.service';
import { EMPTY, expand, map, Observable, reduce } from 'rxjs';
import { HomeService } from 'src/app/modules/home/home.service';
declare let $: any;
@Injectable()
export class WbidHelper {
  private intervalId: any;
  private progress = 0;
  constructor(
    private WbidSwaService: WbidCoreService,
    public loader: LoadingSpinnerService,
    public homeService: HomeService,
  ) {
    /**/
  }

  /**
   * @method getUserId To get current user id
   * @param noNeedSecretUser boolean for exclude secret user
   * @returns employee id as string
   */ public getUserId(noNeedSecretUser?: boolean): string {
    const secretUser = noNeedSecretUser
      ? undefined
      : localStorage.getItem('userSec');
    const isUser = localStorage.getItem('isUser');
    const empnum = localStorage.getItem('empnum');

    return secretUser == undefined || secretUser == null
      ? isUser === 'FA'
        ? empnum?.replace(/x/gi, '') // remove 'x' or 'X' only for FA users
        : empnum?.replace(/x/gi, '').replace(/[^\d.]/g, '') // remove 'x'/'X' and non-digit/period characters
      : secretUser.replace(/x/gi, '').replace(/[^\d.]/g, '');
  }

  public getISOStringWithoutSecsAndMillisecs1(date: Date) {
    try {
      const dateAndTime = date.toISOString().split('T');
      const time = dateAndTime[1].split(':');
      let hour: any = date.getHours();
      hour = hour < 10 ? '0' + hour : hour;
      let min: any = date.getMinutes();
      min = min < 10 ? '0' + min : min;
      let sec: any = date.getSeconds();
      sec = sec < 10 ? '0' + sec : sec;
      const millisec = date.getMilliseconds();
      return dateAndTime[0] + 'T' + hour + ':' + min + ':' + sec;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  getISOStringWithoutSecsAndMillisecs1: ${error.stack.toString()}`;
    }
  }

  public GetMonthNumber(monthName): number {
    let month = -1; // -1 For default
    switch (monthName) {
      case 'Jan':
        month = 1;
        break;
      case 'Feb':
        month = 2;
        break;
      case 'Mar':
        month = 3;
        break;
      case 'Apr':
        month = 4;
        break;
      case 'May':
        month = 5;
        break;
      case 'Jun':
        month = 6;
        break;
      case 'Jul':
        month = 7;
        break;
      case 'Aug':
        month = 8;
        break;
      case 'Sep':
        month = 9;
        break;
      case 'Oct':
        month = 10;
        break;
      case 'Nov':
        month = 11;
        break;
      case 'Dec':
        month = 12;
        break;
      default:
        month = -1;
        break;
    }
    return month;
  }

  public calculateBpStartDayWithYear(
    position: string,
    month: number,
    year: number
  ) {
    try {
      month = month - 1;
      //Javscript Month Starting From Zero

      let startDay;
      if (position == 'FA') {
        if (month == 1) startDay = new Date(year, month - 1, 31);
        else if (month == 2) startDay = new Date(year, month, 2);
        else startDay = new Date(year, month, 1);
      } else {
        startDay = new Date(year, month, 1);
        // startDay=new Date(2019,4,25)
      }
      return startDay;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  calculateBpStartDayWithYear: ${error.stack.toString()}`;
    }
  }
  public calculateBPEndDateWithYear(
    position: string,
    month: number,
    year: number
  ) {
    try {
      let endDay;
      const numberOfDays = moment(
        '' + year + '-' + month + '',
        'YYYY-MM'
      ).daysInMonth(); // DateTime.DaysInMonth(year, month);
      month = month - 1;

      if (position === 'FA') {
        if (month === 1) {
          //February
          endDay = new Date(year, month + 1, 1);
        } else if (month === 0) {
          //January
          endDay = new Date(year, month, 30);
        } else {
          endDay = new Date(year, month, numberOfDays);
        }
      } else {
        if (month === 0) {
          endDay = new Date(year, month, 31);
        } else {
          endDay = new Date(year, month, numberOfDays);
        }
      }
      return endDay;
    } catch (error) {
      throw new Error(
        `ClassName: HelperService, FunctionName:  calculateBPEndDateWithYear: ${error.stack.toString()}`
      );
    }
  }

  public getKeyCombination(BidDataRequest: TblBidDataDisplay): string {
    try {
      return `${BidDataRequest.Month}-${BidDataRequest.Year}-${BidDataRequest.Domicile}-${BidDataRequest.Position}-${BidDataRequest.Round}`;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  getKeyCombination: ${error.stack.toString()}`;
    }
  }

  public getDifferenceInDays(date1, date2) {
    try {
      const now = moment(date2);
      const end = moment(date1);
      const minutes = now.diff(end, 'seconds');
      return minutes;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  getDifferenceInDays : ${error.stack.toString()}`;
    }
  }

  /**
   * @method GetMonthName for getting month name
   * @param monthNumber is month number as number
   */
  public GetMonthName(monthNumber: number): string {
    let month = '';
    switch (monthNumber) {
      case 1:
        month = 'Jan';
        break;
      case 2:
        month = 'Feb';
        break;
      case 3:
        month = 'Mar';
        break;
      case 4:
        month = 'Apr';
        break;
      case 5:
        month = 'May';
        break;
      case 6:
        month = 'Jun';
        break;
      case 7:
        month = 'Jul';
        break;
      case 8:
        month = 'Aug';
        break;
      case 9:
        month = 'Sep';
        break;
      case 10:
        month = 'Oct';
        break;
      case 11:
        month = 'Nov';
        break;
      case 12:
        month = 'Dec';
        break;
      default:
        month = '';
        break;
    }
    return month;
  }

  public detectPlatForm = (): OSVersion => {
    const OSData = new OSVersion();
    OSData.OS = navigator.userAgent.toLowerCase();
    if (OSData.OS.includes('edge')) {
      OSData.BrowserName = 'Microsoft Edge';
      OSData.Version = OSData.OS.substring(OSData.OS.indexOf('edge') + 5);
    } else if (OSData.OS.includes('chrome')) {
      OSData.BrowserName = 'Google Chrome';
      OSData.Version = OSData.OS.substring(
        OSData.OS.indexOf('chrome/') + 7
      ).split(' ')[0];
    } else if (OSData.OS.includes('version')) {
      OSData.BrowserName = 'MAC Version Safari';
      OSData.Version = OSData.OS.substring(
        OSData.OS.indexOf('version/') + 8
      ).split(' ')[0];
    } else if (OSData.OS.includes('firefox')) {
      OSData.BrowserName = 'Firefox';
      OSData.Version = OSData.OS.substring(OSData.OS.indexOf('firefox/') + 8);
    } else {
      OSData.BrowserName = 'Internet Explorer';
      OSData.Version = OSData.OS.substring(OSData.OS.indexOf('rv') + 3).split(
        ')'
      )[0];
    }
    if (OSData.OS.includes('windows')) OSData.OSName = 'Windows';
    else if (OSData.OS.includes('macintosh')) OSData.OSName = 'Macintosh';
    return OSData;
  };

  public setDateV2 = (
    day: number,
    isLastTrip: boolean,
    currentBid: TblBidDataDisplay
  ): string => {
    //  Jan:	Jan 1 to Jan 30
    //   Feb:	Jan 31 to Mar 1
    //    Mar:	Mar 2 to Mar 31
    try {
      let tempMonth = currentBid.Month;
      if (
        currentBid.Position.toLowerCase() === 'fa' &&
        currentBid.Month === 2
      ) {
        if (day === 31) {
          tempMonth--;
        }
        //Eg BAQW01---  in this case  trip start date may either February 1 or  march 1
        else if (day == 1 && isLastTrip) {
          tempMonth++;
        }
      }
      return moment(new Date(currentBid.Year, tempMonth - 1, day)).format();
    } catch (error) {
      //this.crashMail.sendCrashMail(`Function Name:setDateV2  ${error.stack.toString()}`);
    }
  };

  public generateDefaultVacationColumns(): SummaryVacationColumn[] {
    const dataColumns: SummaryVacationColumn[] = [];
    const columns = [
      0, 1, 2, 3, 66, 5, 38, 62, 36, 44, 18, 34, 41, 27, 53, 54, 55,
    ]; // added the vacpaycu(53), vofrnt(54) and vobk(55)
    for (let i = 0; i < 17; ++i) {
      const col: SummaryVacationColumn = new SummaryVacationColumn();
      col.Id = columns[i];
      col.Order = i + 1;
      col.Width = 50;
      dataColumns.push(col);
    }
    return dataColumns;
  }

  public generateDefaultColumns(): DataColumn[] {
    try {
      const dataColumns: DataColumn[] = [];
      const columns = [
        0, 1, 2, 3, 66, 5, 38, 62, 36, 44, 18, 34, 41, 27, 8, 6, 37,
      ];
      for (let i = 0; i < 17; ++i) {
        const col: DataColumn = new DataColumn();
        col.Id = columns[i];
        col.Order = i + 1;
        col.Width = 50;
        dataColumns.push(col);
      }
      return dataColumns;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  generateDefaultColumns: ${error.stack.toString()}`;
    }
  }

  public generateWbidTxtFileNames(
    domicile: string,
    position: string,
    round: number,
    file: string
  ): string {
    try {
      let fileName: string;
      if (file == 'SL') {
        fileName =
          position == 'FA' ? (round == 1 ? 'S' : 'SR') : round == 1 ? 'S' : 'R';
      } else if (file == 'CL') {
        fileName =
          position == 'FA' ? (round == 1 ? 'C' : 'CR') : round == 1 ? 'C' : 'R';
      } else {
        fileName = round == 1 ? 'M' : 'W';
      }
      return domicile + position + fileName + '.TXT';
    } catch (error) {
      throw `ClassName: HelperService, FunctionName:  generateWbidTxtFileNames: ${error.stack.toString()}`;
    }
  }

  public topLockBottomLockManualSync(lockType: string, lockingLine: string) {
    let toplockedManual = localStorage.getItem('toplockedLines');
    const temptoplockedManual = toplockedManual;
    let bottomLockedManual = localStorage.getItem('bottomlockedLines');
    const tepmbottomLockedManual = bottomLockedManual;
    let toplockedManualArray = [];
    let bottomLockedManualArray = [];
    let lockingLineArray = lockingLine.split(',');
    lockingLineArray = lockingLineArray.filter((item) => item);
    let containsInTopLock = [];
    let containsInBotLock = [];
    if (toplockedManual && toplockedManual != 'null') {
      toplockedManualArray = toplockedManual.split(',');
      toplockedManualArray = toplockedManualArray.filter((item) => item);
      containsInTopLock = toplockedManualArray.filter(
        (val) => !lockingLineArray.includes(val)
      );
    }
    if (bottomLockedManual && bottomLockedManual != 'null') {
      bottomLockedManualArray = bottomLockedManual.split(',');
      bottomLockedManualArray = bottomLockedManualArray.filter((item) => item);
      containsInBotLock = bottomLockedManualArray.filter(
        (val) => !lockingLineArray.includes(val)
      );
    }

    if (lockType == 'top') {
      if (toplockedManual && toplockedManual != 'null') {
        const array3 = lockingLineArray.filter(function (obj) {
          return toplockedManualArray.indexOf(obj) == -1;
        });
        toplockedManualArray.push(array3);

        toplockedManual = toplockedManualArray.toString();
      } else {
        toplockedManual = lockingLine;
      }
      if (
        (bottomLockedManual &&
          bottomLockedManual != 'null' &&
          temptoplockedManual &&
          temptoplockedManual != 'null') ||
        containsInBotLock.length > 0
      ) {
        // var array5 = lockingLineArray.filter(function (obj) { return bottomLockedManualArray.indexOf(obj) == -1; });
        // bottomLockedManualArray.push(array5);
        bottomLockedManualArray = bottomLockedManualArray.filter(
          (val) => !lockingLineArray.includes(val)
        );
        bottomLockedManual = bottomLockedManualArray.toString();
      }
    } else {
      if (bottomLockedManual && bottomLockedManual != 'null') {
        const array4 = lockingLineArray.filter(function (obj) {
          return bottomLockedManualArray.indexOf(obj) == -1;
        });
        bottomLockedManualArray.push(array4);

        bottomLockedManual = bottomLockedManualArray.toString();
      } else {
        bottomLockedManual = lockingLine;
      }
      if (
        (toplockedManual &&
          toplockedManual != 'null' &&
          tepmbottomLockedManual &&
          tepmbottomLockedManual != 'null') ||
        containsInTopLock.length > 0
      ) {
        // var array6 = lockingLineArray.filter(function (obj) { return toplockedManualArray.indexOf(obj) == -1; });
        // toplockedManualArray.push(array6);
        toplockedManualArray = toplockedManualArray.filter(
          (val) => !lockingLineArray.includes(val)
        );
        toplockedManual = toplockedManualArray.toString();
      }
    }
    localStorage.removeItem('toplockedLines');
    localStorage.removeItem('bottomlockedLines');
    localStorage.setItem('toplockedLines', toplockedManual);
    localStorage.setItem('bottomlockedLines', bottomLockedManual);
  }

  public generateCalenderData(BidData: TblBidDataDisplay): List<CalenderData> {
    try {
      let iterationCount: number = this.getDateDayofWeek(
        BidData.BidPeriodStartDate
      );
      const lstDayOfMonth: List<CalenderData> = new List<CalenderData>();
      let id = 1;
      for (let count = 0; count < iterationCount; count++) {
        const CalenderDataObj = new CalenderData();
        (CalenderDataObj.Id = id),
          (CalenderDataObj.IsEnabled = false),
          (CalenderDataObj.Day = '');

        lstDayOfMonth.Add(CalenderDataObj);
        id++;
      }

      const StartDate: Date = new Date(BidData.BidPeriodStartDate);
      const EndDate: Date = new Date(BidData.BidPeriodEndDate);

      const date1 = new Date(EndDate);
      const date2 = new Date(StartDate);
      const timeDiff = Math.abs(date2.getTime() - date1.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      //alert(diffDays);

      const ts = diffDays; // EndDate.getDate() -StartDate.getDate();
      iterationCount = ts + 1;

      if (BidData.Position == 'FA') {
        if (BidData.Month == 1) iterationCount++;
        else if (BidData.Month == 2) iterationCount--;
      }
      let calenderDate: any = StartDate;
      for (let count = 1; count <= iterationCount; count++) {
        const CalenderDataObj = new CalenderData();
        CalenderDataObj.Id = id;
        CalenderDataObj.IsEnabled = true;
        CalenderDataObj.Day = new Date(calenderDate).getDate().toString();
        CalenderDataObj.DateStr = moment(new Date(calenderDate)).format(
          'YYYY-MM-DD'
        );
        lstDayOfMonth.Add(CalenderDataObj);

        calenderDate = moment(calenderDate).add(1, 'days');
        //  calenderDate =// new Date(calenderDate.getFullYear(),calenderDate.getMonth()-1,calenderDate.getDate()+1)//         calenderDate.AddDays(1);
        id++;
      }

      for (let count = 1; count <= 35 - iterationCount; count++) {
        const CalenderDataObj = new CalenderData();
        CalenderDataObj.Id = id;
        CalenderDataObj.IsEnabled = true;
        CalenderDataObj.Day = new Date(calenderDate).getDate().toString(); //count.toString();
        CalenderDataObj.DateStr = moment(new Date(calenderDate)).format(
          'YYYY-MM-DD'
        );
        lstDayOfMonth.Add(CalenderDataObj);
        calenderDate = moment(calenderDate).add(1, 'days');
        id++;
      }

      for (let count = id; count <= 41; count++) {
        const CalenderDataObj = new CalenderData();
        CalenderDataObj.Id = id;
        CalenderDataObj.IsEnabled = false;
        CalenderDataObj.Day = '';
        CalenderDataObj.DateStr = moment(new Date(calenderDate)).format(
          'YYYY-MM-DD'
        );
        lstDayOfMonth.Add(CalenderDataObj);
        calenderDate = moment(calenderDate).add(1, 'days');
        id++;
      }

      return lstDayOfMonth;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  generateCalenderData: ${error.stack.toString()}`;
    }
  }

  public getDateDayofWeek(StartDate): number {
    try {
      const DayString = moment(new Date(StartDate)).format('dddd');
      let Day;
      switch (DayString) {
        case 'Sunday':
          Day = 0;
          break;
        case 'Monday':
          Day = 1;
          break;
        case 'Tuesday':
          Day = 2;
          break;
        case 'Wednesday':
          Day = 3;
          break;
        case 'Thursday':
          Day = 4;
          break;
        case 'Friday':
          Day = 5;
          break;
        case 'Saturday':
          Day = 6;
          break;

        default:
          break;
      }
      return Day;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  getDateDayofWeek: ${error.stack.toString()}`;
    }
  }

  public setDate(day: number, isLastTrip: boolean, CurrentBid) {
    //  Jan:	Jan 1 to Jan 30
    //   Feb:	Jan 31 to Mar 1
    //    Mar:	Mar 2 to Mar 31
    try {
      let tempMonth = CurrentBid.Month;
      if (CurrentBid.Position == 'FA' && CurrentBid.Month == 2) {
        if (day == 31) {
          tempMonth--;
        }
        //Eg BAQW01---  in this case  trip start date may either February 1 or  march 1
        else if (day == 1 && isLastTrip) {
          tempMonth++;
        }
      }
      return new Date(CurrentBid.Year, tempMonth - 1, day);
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  setDate: ${error.stack.toString()}`;
    }
  }

  public compareVersion(version1, version2) {
    try {
      let flag = false;
      let compareResult;
      const maxLength = Math.max(version1.length, version2.length);
      const minLength = Math.min(version1.length, version2.length);

      for (let i = 0; i < maxLength; ++i) {
        const result = version1[i] - version2[i];
        if (result > 0) {
          flag = true;
          compareResult = 0;
          break;
        } else if (result < 0) {
          flag = true;
          compareResult = 1;
          break;
        }

        if (i === minLength) {
          if (version1.length > version1.length) {
            compareResult = version1[version1.length - 1] > 0 ? '0' : '-1';
          } else {
            compareResult = version1[version2.length - 1] > 0 ? '1' : '-1';
          }
          break;
        }
      }
      if (flag === false) {
        compareResult = -1;
      }
      return compareResult;
    } catch (error) {
      throw `ClassName: helper, FunctionName:  compareVersion: ${error.stack.toString()}`;
    }
  }

  public convertMinutesToFormattedHour(minutes: number): string {
    try {
      const hhh = Math.floor(minutes / 60)
        .toString()
        .padStart(2, '0');
      const mm = Math.ceil(minutes % 60)
        .toString()
        .padStart(2, '0');
      return hhh + ':' + mm;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: convertMinutesToFormattedHour, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public domicileTimeFromHerb(
    domicile: string,
    dutPdDate: Date,
    herb: number
  ): number {
    try {
      switch (domicile) {
        case 'ATL':
          return herb + 60; // EST = herb + 60
        case 'BWI':
          return herb + 60; // EST = herb + 60
        case 'AUS':
          return herb; // CST = herb
        case 'DAL':
          return herb; // CST = herb
        case 'DEN':
          return herb - 60; // MST = herb - 60
        case 'FLL':
          return herb + 60; // EST = herb + 60
        case 'HOU':
          return herb; // CST = herb
        case 'LAS':
          return herb - 120; // PST = herb - 120
        case 'LAX':
          return herb - 120; // PST = herb - 120
        case 'MCO':
          return herb + 60; // EST = herb + 60
        case 'MDW':
          return herb; // CST = herb
        case 'OAK':
          return herb - 120; // PST = herb - 120
        case 'PHX':
          return herb - 60; // MST = herb - 60
        case 'BNA':
          return herb;
        default:
          return 1440;
      }
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: domicileTimeFromHerb, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public calcTimeFromMinutesFromMidnight(tm: string): string {
    try {
      let minutes: string = null;
      let hours: string = null;
      const mins = Number(tm);
      const days: number = Math.trunc(mins % (60 * 24));
      const hrs: number = Math.trunc(days / 60);
      const mns: number = Math.trunc(days % 60);
      if (hrs < 10) hours = '0' + Math.floor(hrs).toString();
      else hours = Math.floor(hrs).toString();
      if (mns.toString().length == 1) minutes = '0' + Math.ceil(mns).toString();
      else minutes = Math.ceil(mns).toString();
      const displayTime: string = hours + ':' + minutes;
      return displayTime;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: calcTimeFromMinutesFromMidnight, ErrorMessage: ${error.stack.toString()}`;
    }
  }
  public calcTimeFromMinutes(tm: string): string {
    try {
      let minutes: string | null = null;
      let hours: string | null = null;

      const mins = Math.floor(Number(tm));
      const day = Math.floor(mins / (60 * 24));
      const days = mins % (60 * 24);
      let hrs = Math.floor(days / 60);
      const mns = days % 60;

      hrs = hrs + day * 24;

      hours = hrs < 10 ? '0' + hrs.toString() : hrs.toString();
      minutes = mns < 10 ? '0' + mns.toString() : mns.toString();

      const displayTime = `${hours}:${minutes}`;
      return displayTime;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: calcTimeFromMinutes, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public timeFromMinutes(minutes: string): string {
    try {
      let time = '';
      const hour: number = Math.trunc(Number(minutes) / 60);
      const minute: number = Math.trunc(Number(minutes) % 60);
      time = hour.toString() + ':' + minute.toString().padStart(2, '0');
      return time;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: timeFromMinutes, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public convertMinutesToHhhmm(minutes: number): string {
    try {
      const hhh: string = Math.trunc(minutes / 60).toString();
      const mm: string = Math.trunc(minutes % 60).toString();
      return hhh.padStart(2, '0') + ':' + mm.padStart(2, '0');
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: convertMinutesToHhhmm, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public GetNumberRange(from: number, to: number) {
    const data = [];
    for (let index = from; index < to + 1; index++) {
      data.push(index);
    }
    return data;
  }

  public getNumberRangeForItemType(from: number, to: number): ItemType[] {
    const items: ItemType[] = [];
    for (let index = from; index <= to; ++index) {
      items.push(new ItemType(index, index));
    }
    return items;
  }
  public getNumberRangeForAircraftChanges(
    from: number,
    to: number
  ): ItemType[] {
    const items: ItemType[] = [];
    for (let index = from; index <= to; ++index) {
      items.push(new ItemType(index + ' chg', index));
    }
    return items;
  }

  public getNumberRangeForBDO(from: number, to: number): ItemType[] {
    const items: ItemType[] = [];
    for (let index = from; index <= to; ++index) {
      items.push(new ItemType('blk ' + index, index));
    }
    return items;
  }

  public getNumberRangeForEquipmentType(from: number, to: number): ItemType[] {
    const items: ItemType[] = [];
    for (let index = from; index <= to; ++index) {
      items.push(new ItemType(index + ' legs', index));
    }
    return items;
  }

  public getNumberRangeForWorkDaysWeight(from: number, to: number): ItemType[] {
    const items: ItemType[] = [];
    for (let index = from; index <= to; ++index) {
      items.push(new ItemType(index + ' wk days', index));
    }
    return items;
  }

  public getNumberRangeForGroundTime(from: number, to: number): ItemType[] {
    const items: ItemType[] = [];
    for (let index = from; index <= to; ++index) {
      items.push(new ItemType(index + ' occurs', index));
    }
    return items;
  }

  public getNumberRangeOffType(from: number, to: number): ItemType[] {
    const items: ItemType[] = [];
    for (let index = from; index <= to; ++index) {
      items.push(new ItemType(index + ' off', index));
    }
    return items;
  }

  public getWeeksStartAndEndInMonth(_month, _year, returnDate?) {
    const monthYear = _month + '/' + _year;
    const lasDay = moment(monthYear, 'MM/YYYY')
      .endOf('month')
      .format('MM/DD/YYYY');
    const getLastDate = parseInt(moment(lasDay).format('DD'));
    const weeks = [];
    let _days = [];
    const codes = ['A', 'B', 'C', 'D', 'E', 'F'];
    for (let day = 1; day <= getLastDate; day++) {
      const thisDay = moment(_month + '/' + day + '/' + _year, 'MM/DD/YYYY');
      const getthisDay = thisDay.weekday();
      const getthidDate = parseInt(moment(thisDay).format('DD'));
      _days.push(
        returnDate
          ? thisDay
          : moment(_month + '/' + day + '/' + _year, 'MM/DD/YYYY').format(
              'MM/DD/YYYY'
            )
      );
      if (getthisDay === 6) {
        weeks.push({ start: _days[0], end: _days[_days.length - 1], code: '' });
        _days = [];
      } else if (getthidDate === getLastDate) {
        weeks.push({ start: _days[0], end: _days[_days.length - 1], code: '' });
      }
    }
    weeks[0].start = moment(weeks[0].end, 'MM/DD/YYYY')
      .subtract(6, 'days')
      .format('MM/DD/YYYY');
    weeks[weeks.length - 1].end = moment(
      weeks[weeks.length - 1].start,
      'MM/DD/YYYY'
    )
      .add(6, 'days')
      .format('MM/DD/YYYY');
    for (let i = 0; i < weeks.length; i++) {
      weeks[i].code = codes[i];
    }
    return weeks;
  }

  public convertHhhColonMmToFractionalHours(hhmm: string) {
    try {
      let splitHhhmm: string[];
      splitHhhmm = hhmm.split(':');
      const hh = Number(splitHhhmm[0]);
      const mm = Number(splitHhhmm[1]);
      return hh + mm / 60;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: convertHhhColonMmToFractionalHours, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public convertLineArrayToList(linearray: Lines[]) {
    try {
      const lines = new List<Lines>();
      linearray.forEach((x) => lines.Add(x));
      return lines;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  convertLineArrayToList ${error.stack.toString()}`;
    }
  }

  public highlightRow(id: string, needscroll?, showColor?) {
    try {
      const SearchLine = $('.bid[lino="' + id + '"]')[0];
      const table = $(SearchLine).find('table')[0];
      if (SearchLine) {
        table.style.border = showColor ? '5px solid blue' : '';
        if (needscroll) {
          const Ypos = this.findPos($('.bid[lino="' + id + '"]')[0]);
          window.scroll(0, Ypos);
          return true;
        }
      } else {
        return false;
      }
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  highlightRow: ${error.stack.toString()}`;
    }
  }

  public findPos(obj): number {
    try {
      let curtop = 0;
      if (obj.offsetParent) {
        do {
          const t = obj.offsetTop;
          curtop += t;
        } while ((obj = obj.offsetParent));
        const tt = curtop - 85;
        return tt;
      }
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  findPos: ${error.stack.toString()}`;
    }
  }

  public removeHighlightRow() {
    try {
      const bidlines = document.getElementsByClassName('bid');

      for (let index = 0; index < bidlines.length; index++) {
        const element = $(bidlines[index]).find('table')[0];
        if (element.style.border) {
          element.style.border = '';
        }
      }
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  removeHighlightRow: ${error.stack.toString()}`;
    }
  }
public removeSeconds(input: string, ColumnName?: string) {
    try {
      if (input == 'null') {
        return '';
      }

      //  Handle special time format like "1.00:45" → "00:45"
      if (input.includes('.') && input.includes(':')) {
        const [hourPart, minPart] = input.split(':');
        const hourTokens = hourPart.split('.');

        // take the number after the dot as hours
        const hours = parseInt(hourTokens[1] || '0', 10);
        const minutes = parseInt(minPart, 10);

        return `${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')}`;
      }

      if (ColumnName) {
        if (
          ColumnName == 'AEDP' ||
          ColumnName == 'ALDA' ||
          ColumnName == 'LArr' ||
          ColumnName == 'LDOMArr' ||
          ColumnName == 'MinPayRig' ||
          ColumnName == 'LineRig' ||
          ColumnName == 'MyValue' ||
          ColumnName == 'nMid'
        ) {
          if (input.includes(':')) {
            const Splitted = input.split(':');
            return Splitted[0] + ':' + Splitted[1];
          } else {
            return input;
          }
        } else {
          return input;
        }
      } else {
        if (input.includes(':')) {
          const Splitted = input.split(':');
          return Splitted[0] + ':' + Splitted[1];
        } else {
          return input;
        }
      }
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: removeSeconds -> ${
        error.stack?.toString?.() || error
      }`;
    }
  }

  public getFirstSunday(year, month): any {
    for (let i = 1; i <= 3; i++) {
      const date =
        month.toString() + '/' + i.toString() + '/' + year.toString();
      if (moment(date, 'MM/DD/YYYY').format('dddd') == 'Sunday') {
        return moment(date, 'MM/DD/YYYY').format('MM/DD/YYYY');
      }
    }
  }

  public setTripColor(
    line: Lines,
    temp: BidLineTemplate,
    isVacationEnabled: boolean,
    isEomEnabled: boolean,
    isMilEnabled: boolean,
    trip?,
    isRedEye?: boolean, //Red eye flight chnages
    currentBid?
  ) {
    try {
      let BackgroundTripColor = '';

      if (trip) {
        //Red eye flight chnages
        if (isRedEye && temp.BidLineType == 0) {
          BackgroundTripColor = ColorClass.RedEyeTripColor;
          return BackgroundTripColor;
        }
        //Red eye flight chnages ends
        if (temp.DayOfWeek.includes('SA') || temp.DayOfWeek.includes('SU')) {
          BackgroundTripColor = ColorClass.weekendTripColor;
        } else {
          BackgroundTripColor = ColorClass.normTripColor;
        }
        if (!temp.IsInCurrentMonth) {
          // Not Current Month
          BackgroundTripColor = ColorClass.nextMonthTripColor;
        }
        if (!line.ReserveLine) {
          // For Non Reserve Lines
          if (temp.AMPMType == '1') {
            // AM
            BackgroundTripColor = ColorClass.AMTripColor;
          } else if (temp.AMPMType == '2') {
            //PM
            BackgroundTripColor = ColorClass.PMTripColor;
          } else if (temp.AMPMType == '3') {
            //Mix
            BackgroundTripColor = ColorClass.MixedTripColor;
          } else if (
            temp.AMPMType == null &&
            temp.ArrStaLastLeg != null &&
            temp.ArrStaLastLeg != ''
          ) {
            BackgroundTripColor = ColorClass.MissedTrip;
          }
        } else {
          // For Reserve and ReadyReserve Lines
          if (
            line.LineDisplay.includes('RR') &&
            (temp.AMPMType == '1' ||
              temp.AMPMType == '2' ||
              temp.AMPMType == '3')
          ) {
            BackgroundTripColor = ColorClass.ReadyReserveColor;
          } else {
            if (temp.AMPMType == '1') {
              // AM
              BackgroundTripColor = ColorClass.AMReserveTripColor;
            } else if (temp.AMPMType == '2') {
              //PM
              BackgroundTripColor = ColorClass.PMReserveTripColor;
            } else if (temp.AMPMType == '3') {
              //Mix
              BackgroundTripColor = ColorClass.MixedTripColor;
            } else if (
              temp.AMPMType == null &&
              temp.ArrStaLastLeg != null &&
              temp.ArrStaLastLeg != ''
            ) {
              BackgroundTripColor = ColorClass.MissedTrip;
            }
          }
        }

        if (isVacationEnabled || isEomEnabled) {
          // Not Reserve Line
          if (temp.BidLineType == BidLineType.VAP) {
            BackgroundTripColor = ColorClass.VAPColor;
          } else if (temp.BidLineType == BidLineType.VO) {
            BackgroundTripColor = ColorClass.VacationOverlapTripColor;
          } else if (temp.BidLineType == BidLineType.VD) {
            BackgroundTripColor = ColorClass.VacationDropTripColor;
          } else if (temp.BidLineType == BidLineType.VDDrop) {
            BackgroundTripColor = ''; //UIColor.Clear;
          } else if (temp.BidLineType == BidLineType.VA) {
            BackgroundTripColor = ColorClass.VacationTripColor;
          } else if (temp.BidLineType == BidLineType.VOFSplit) {
            BackgroundTripColor = ColorClass.VacationOverlapTripColor;
            // drawSplitShapes(lblTripName[index].Frame, shapeOffset, 1, ColorClass.VacationDropTripColor, ColorClass.VacationOverlapTripColor);
          } else if (temp.BidLineType == BidLineType.VOFSplitDrop) {
            // drawSplitShapes(lblTripName[index].Frame, shapeOffset, 1, UIColor.White, ColorClass.VacationOverlapTripColor);
            //debugger
          } else if (temp.BidLineType == BidLineType.VOBSplit) {
            BackgroundTripColor = ColorClass.VacationOverlapTripColor;
            // drawSplitShapes(lblTripName[index].Frame, shapeOffset, 2, ColorClass.VacationOverlapTripColor, ColorClass.VacationDropTripColor);
          } else if (temp.BidLineType == BidLineType.VOBSplitDrop) {
            // drawSplitShapes(lblTripName[index].Frame, shapeOffset, 2, ColorClass.VacationOverlapTripColor, UIColor.White);
          } else if (temp.BidLineType == BidLineType.FV) {
            BackgroundTripColor = ColorClass.FVVacationColor;
          }
          // clawback changes
          if (
            line.clawBack > 0 &&
            temp.BidLineType == BidLineType.VA &&
            currentBid.BidPeriodEndDate < temp.Date
          ) {
            BackgroundTripColor = ColorClass.ClawbackTripColor;
          }
        } else if (isMilEnabled) {
          if (temp.TripBackColor == '#ffa500') BackgroundTripColor = '#ffa500';
        }
      } else {
        if (temp.DayOfWeek.includes('SA') || temp.DayOfWeek.includes('SU')) {
          // Weekend Days
          BackgroundTripColor = ColorClass.weekendDayColor;
        } else {
          // Normal Days
          BackgroundTripColor = ColorClass.normDayColor;
        }
      }
      if (trip && temp.TripNumDisplay == '$FV') {
        BackgroundTripColor = '#969693';
      }

      return BackgroundTripColor;
    } catch (error) {
      throw `ClassName: HelperService, FunctionName:  setTripColor: ${error.stack.toString()}`;
    }
  }

  public createGuid() {
    try {
      return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0,
          v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    } catch (error) {
      throw `ClassName: HelperService, FunctionName: createGuid  ${error.stack.toString()}`;
    }
  }

  public convertMinuteToHHMM(minute: number): string {
    try {
      let result = '';
      result = Math.floor(minute / 60)
        .toString()
        .padStart(2, '0');
      result += ':';
      result += Math.floor(minute % 60)
        .toString()
        .padStart(2, '0');
      return result;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: convertMinuteToHHMM, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public convertHHMMToMinutes(hhmm): number {
    try {
      if (typeof hhmm == 'object') {
        hhmm = hhmm.format('HH:m');
      }
      let result = 0;
      if (hhmm == '' || hhmm == null || hhmm == '--:--') return result;

      const temp = hhmm.split(':');
      result = Number(temp[0]) * 60 + Number(temp[1]);
      return result;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: convertHHMMToMinutes, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public getDefaultBidOptions() {
    return {
      Base: [
        { domicileName: 'ATL', isBaseEnabled: true },
        { domicileName: 'AUS', isBaseEnabled: true },
        { domicileName: 'BWI', isBaseEnabled: true },
        { domicileName: 'DAL', isBaseEnabled: true },
        { domicileName: 'DEN', isBaseEnabled: true },
        { domicileName: 'FLL', isBaseEnabled: true },
        { domicileName: 'HOU', isBaseEnabled: true },
        { domicileName: 'LAS', isBaseEnabled: true },
        { domicileName: 'LAX', isBaseEnabled: true },
        { domicileName: 'MCO', isBaseEnabled: true },
        { domicileName: 'MDW', isBaseEnabled: true },
        { domicileName: 'OAK', isBaseEnabled: true },
        { domicileName: 'PHX', isBaseEnabled: true },
        { domicileName: 'BNA', isBaseEnabled: true },
      ],
      Positions: [{ btnname: 'CP' }, { btnname: 'FO' }, { btnname: 'FA' }],

      Rounds: [
        { btnname: '1st Round', id: 1 },
        { btnname: '2nd Round', id: 2 },
      ],
      Months: [
        { btnname: 'Jan', id: 1, isMonthEnabled: true },
        { btnname: 'Feb', id: 2, isMonthEnabled: true },
        { btnname: 'Mar', id: 3, isMonthEnabled: true },
        { btnname: 'Apr', id: 4, isMonthEnabled: true },
        { btnname: 'May', id: 5, isMonthEnabled: true },
        { btnname: 'Jun', id: 6, isMonthEnabled: true },
        { btnname: 'Jul', id: 7, isMonthEnabled: true },
        { btnname: 'Aug', id: 8, isMonthEnabled: true },
        { btnname: 'Sep', id: 9, isMonthEnabled: true },
        { btnname: 'Oct', id: 10, isMonthEnabled: true },
        { btnname: 'Nov', id: 11, isMonthEnabled: true },
        { btnname: 'Dec', id: 12, isMonthEnabled: true },
      ],

      Year: [],
    };
  }

  public padLeft(num: number, size: number): string {
    let s = num + '';
    while (s.length < size) s = '0' + s;
    return s;
  }

  public generateTimeList(): BindingManager[] {
    try {
      const timeList: any[] = [];
      const start = 5;
      const end = 16;
      const intrvl = 5;
      let count: number;
      let intervel: number;
      for (count = start; count < end; count++) {
        for (intervel = 0; intervel < 60; intervel = intervel + intrvl) {
          timeList.push(
            new BindingManager(
              count * 60 + intervel,
              count.toString().padStart(2, '0') +
                ':' +
                intervel.toString().padStart(2, '0'),
              false
            )
          );
        }
      }
      timeList.push(
        new BindingManager(end * 60, end.toString() + ':00', false)
      );

      return timeList;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: generateTimeList, ErrorMessage: ${error.stack.toString()}`;
    }
  }

  public generateGroundTimeList(): BindingManager[] {
    try {
      const grndTimeList: any[] = [];
      const start = 0;
      const end = 6;
      const intrvl = 5;
      let count: number;
      let intervel: number;

      for (count = start; count < end; count++) {
        for (intervel = 0; intervel < 60; intervel = intervel + intrvl) {
          grndTimeList.push(
            new BindingManager(
              count * 60 + intervel,
              count.toString().padStart(2, '0') +
                ':' +
                intervel.toString().padStart(2, '0'),
              false
            )
          );
        }
      }
      grndTimeList.push(
        new BindingManager(
          end * 60,
          end.toString().padStart(2, '0') + ':00',
          false
        )
      );
      return grndTimeList;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: generateGroundTimeList, ErrorMessage: ${error.stack.toString()}`;
    }
  }
  public ConvertHhhColonMmToFractionalHour(hhmm: any) {
    try {
      const splitHhhmm: string[] = hhmm.split(':');
      const hh: number = parseInt(splitHhhmm[0]);
      const mm: number = parseInt(splitHhhmm[1]);
      return hh + mm / 60;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName: ConvertHhhColonMmToFractionalHour, ErrorMessage: ${error.stack.toString()}`;
    }
  }
  public encryptDecrypt(data: string, isEncrypt: boolean): string {
    try {
      let key = '0'; //key should be same for both encrypt and decrypt.
      if (isEncrypt) {
        let encryptdata = CryptoJS.AES.encrypt(String(data), key).toString();
        return encryptdata;
      } else {
        let decryptData = CryptoJS.AES.decrypt(String(data), key).toString(
          CryptoJS.enc.Utf8
        );
        return decryptData;
      }
    } catch (error) {
      throw `ClassName: HelperService, FunctionName: encryptDecrypt, ErrorMessage: ${error.stack.toString()}`;
    }
  }
  /**
   * @method logEventDetails to add logevent details
   */
  public logEventDetails(currentBid: TblBidDataDisplay, eventName, logMessage) {
    try {
      let logDetails: LogDetails = {
        employeeNumber: Number(currentBid.EmpNum),
        event: eventName,
        base: currentBid.Domicile,
        month: currentBid.Month.toString(),
        position: currentBid.Position,
        round: currentBid.Round,
        message: logMessage,
        operatingSystemNum: 'Web',
        versionNumber: environment.version,
        platformNumber: 'Web',
        bidForEmpNum: Number(currentBid.EmpNum),
        date: moment().format('YYYY-MM-DD HH:mm:ss'),
        fromAppNum: 7,
        ipAddress: '',
      };
      this.addLogEventDetails(logDetails);
    } catch (error) {
      // this.crashMail.sendCrashMail(
      //   `Function Name: logDetailsForCertifyUser  ${error.stack.toString()}`
      // );
    }
  }
  /**
   * @method addLogEventDetails to add logevent details
   */
  public addLogEventDetails(logDetail: LogDetails) {
    try {
      let logData: LogData = {
        logDetails: logDetail,
        date: moment().format('YYYY-MM-DD HH:mm:ss'),
      };
      let offLineEvents: OffLineEvents = {
        eventLogs: [logData],
      };
      this.WbidSwaService.LogOffLineEvents(offLineEvents).subscribe((res) => {
        if (res) {
        }
      });
    } catch (error) {
      // this.crashMail.sendCrashMail(
      //   `Function Name: addlogEventDetails  ${error.stack.toString()}`
      // );
    }
  }
  public generatePacketId(
    BidDataRequest: Pick<
      TblBidDataDisplay,
      'Domicile' | 'Year' | 'Month' | 'Round'
    >
  ): string {
    try {
      const paddedMonth = BidDataRequest.Month.toString().padStart(2, '0');
      return `${BidDataRequest.Domicile}${BidDataRequest.Year}${paddedMonth}${BidDataRequest.Round}`;
    } catch (error) {
      throw `ClassName: WbidHelper, FunctionName:  generatePacketId: ${error.stack.toString()}`;
    }
  }

public fetchFullSeniorityListFromSWAapi(
  packetId: string,
  round: number
): Observable<any[]> 
{ 
try{
 const pageSize = 500;

  const getPage = (page: number) => {

    if (round === 1) {
      return this.homeService
        .getSeniorityList(packetId, page, pageSize);
    }

    if (round === 2) {
      return this.homeService
        .get2ndRoundSeniorityList(packetId, page, pageSize);
    }

    return EMPTY;
  };

  return getPage(0).pipe(

    expand((res: any) => {

      const currentPage = res?.page?.number ?? 0;
      const totalPages = res?.page?.totalPages ?? 0;

      return currentPage + 1 < totalPages
        ? getPage(currentPage + 1)
        : EMPTY;
    }),

    map((res: any) => {

      if (round === 1) {
        return res?._embedded?.IFLineBaseAuctionSeniorities ?? [];
      }

      if (round === 2) {
        return res?._embedded?.IFLineBaseAuctionReserveExternal ?? [];
      }

      return [];
    }),

    reduce((acc, curr) => acc.concat(curr), [])

  );
} catch (error) {
  throw `ClassName: WbidHelper, FunctionName:  fetchFullSeniorityListFromSWAapi: ${error.stack.toString()}`;
}

}

 
}
